var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B731111A-6F86-4617-B0C7-29ACB4EA3B1D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new_Q4_GVT-experience",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GVT_UNAUTH_landing_desktop",
    transform: "translate(-1205.000000, -3926.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Primary-/-Building-Blocks--/--+-Icon-/-Outlined-Blue",
    transform: "translate(1038.000000, 3895.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-Text-/-Blue-/-With-Icon-/-Default",
    transform: "translate(24.000000, 24.129032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(143.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20064507,6.04209653 L6.53460556,6.04209653 L4.58889934,6.96762718 L4.95256014,7.72465315 L6.30157237,7.05727499 L6.30157237,12.3531365 L7.20064507,12.3531365 L7.20064507,6.04209653 Z M8.40048381,2.47112534 C8.62061551,2.47112534 8.80043005,2.28601921 8.80043005,2.05940946 L8.80043005,0.411715878 C8.80043005,0.185106131 8.62061551,0 8.40048381,0 C8.1803521,0 8.00053756,0.185106131 8.00053756,0.411715878 L8.00053756,2.05940946 C8.00053756,2.28601921 8.1803521,2.47112534 8.40048381,2.47112534 L8.40048381,2.47112534 Z M0.800698831,13.1765682 L11.2009139,13.1765682 L11.2009139,4.94142061 L0.800698831,4.94142061 L0.800698831,13.1765682 Z M12,1.64769358 L12,14 L0,14 L0,1.64769358 L2.40048381,1.64769358 L2.40048381,2.05940946 C2.40048381,2.73840863 2.94073377,3.2945571 3.60032254,3.2945571 C4.26071765,3.2945571 4.80016127,2.73840863 4.80016127,2.05940946 L4.80016127,1.64769358 L7.20064507,1.64769358 L7.20064507,2.05940946 C7.20064507,2.73840863 7.74089504,3.2945571 8.40048381,3.2945571 C9.06087891,3.2945571 9.60112888,2.73840863 9.60112888,2.05940946 L9.60112888,1.64769358 L12,1.64769358 Z M3.20037629,2.05940946 L3.20037629,0.411715878 C3.20037629,0.185106131 3.38099718,0 3.60032254,0 C3.82126058,0 4.00026878,0.185106131 4.00026878,0.411715878 L4.00026878,2.05940946 C4.00026878,2.28601921 3.82126058,2.47112534 3.60032254,2.47112534 C3.38099718,2.47112534 3.20037629,2.28601921 3.20037629,2.05940946 L3.20037629,2.05940946 Z",
    id: "Calendar"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.eaa19a3cffa0ca0e5199338eaff04d68.svg";
export { ForwardRef as ReactComponent };